<template lang="pug">
div(:class="[$style.headerGrid, {'narrow-lhs': narrowLhs, 'is-ppc': isPPC}]")
  Block(
     v-for="(innerBlock, key) in block.innerBlocks"
    :key="`headerBlock${key}`"
    :id="'header-block-' + key"
    :class="['header-block', { 'with-rocket': hasRocket && key === 1 }]"
    :block="innerBlock"
    :block-id="blockId"
    :lazy="false")
</template>

<script lang="ts">
import { defineComponent, onMounted } from "vue"

export default defineComponent({
  props: {
    block: { required: true, type: Object as () => Block },
    blockId: { default: "", type: String },
    narrowLhs: { default: false, type: Boolean },
    isPPC: { default: false, type: Boolean }
  },
  setup(props) {
    const hasRocket = computed(() => {
    // Find the className attribute
    const classAttr = props.block.attributes?.find(attr =>
      attr.name === 'className'
    )
    return classAttr?.value?.includes('with-rocket') || false
  })
    return {
      hasRocket
    }
  }
})
</script>

<style lang="css" module>
.headerGrid {
  @apply grid gap-y-ds-sm mb-ds-md;

  &:global(.narrow-lhs) {
    @apply gap-y-ds-md lg:gap-y-ds-sm;
  }

  grid-template-columns: 3fr 1fr;
  grid-template-rows: min-content min-content 1fr;
  align-items: center;
  grid-template-areas:
    "header image"
    "paragraph image"
    "locationForm locationForm";

  &:global(.content) {
    @apply py-0;
  }

  &:global(.is-ppc) {
    :global(.query-maintitle) {
      opacity: 0;
    }
  }

  &:global(:not(.is-ppc)) {
    :global(.query-maintitle) {
      opacity: 1;
    }
  }

  :global {
    .av-heading {
      @apply text-rebrandXm xs:text-rebrandLg md:text-rebrand2xm xl:text-rebrandXl leading-normal m-0 lg:mb-ds-sm mt-ds-md md:mt-ds-lg lg:mt-ds-xxl;
    }
    .av-paragraph {
      @apply flex items-center gap-ds-xxxs mb-ds-md text-base xs:text-rebrandSm md:text-rebrandMd lg:text-rebrandMd leading-normal m-0 lg:mb-ds-md;
    }
    .av-paragraph p {
      @apply m-0;
    }

    /* Apply emoji to header blocks with with-rocket class */
    .header-block.with-rocket::before {
      content: '🚀';
      font-size: 2rem;
      margin-right: 12px;
      display: inline-block;
    }

  }

  > *:nth-child(1) {
    @apply self-end lg:justify-self-start;
    grid-area: header;
  }

  > *:nth-child(2) {
    @apply self-start;
    grid-area: paragraph;
  }

  > *:nth-child(3) {
    @apply w-full relative lg:static overflow-hidden self-center justify-self-center -right-ds-md md:right-0 mt-ds-md lg:m-0;
    grid-area: image; /* or LocationFormExtension */

    &:has(:global(.extension-block-container)) {
      @apply h-[calc(100%-105px)] self-start mt-ds-xxl overflow-visible;
    }

    img {
      width: 100%;
    }
  }

  > *:nth-child(4) {
    @apply self-start mb-ds-md md:mb-ds-lg;
    grid-area: locationForm;

    :global {
      .form-item {
        @apply mt-0;
      }
    }
  }
}

@screen lg {
  .headerGrid {
    @apply gap-x-ds-ml items-center;

    grid-template-columns: 7fr 5fr;
    grid-template-areas:
      "header image"
      "paragraph image"
      "locationForm image";

    &:global(.narrow-lhs) {
      @apply gap-x-ds-xl;
      grid-template-columns: 1fr 1fr;
    }
  }
}

@screen xl {
  .headerGrid:global(.narrow-lhs) {
    @apply gap-x-ds-xxl;
  }
}
</style>
